import { memo } from 'react';

import { Button, alpha } from '@mui/material';
import { Check, X } from 'lucide-react';

import { useChipStatusColor } from '@modules/_shared/components/feed-v2/components/statusChipStyles';

type Props = {
  variant: 'negative' | 'positive';
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
};

const variantIcons = {
  negative: X,
  positive: Check,
};

export const ActionButton = memo(
  ({ variant, onClick, disabled, children }: Props) => {
    const color = useChipStatusColor({
      status: variant === 'positive' ? 'success' : 'error',
    });
    const Icon = variantIcons[variant];

    return (
      <Button
        variant="action"
        startIcon={<Icon size={16} />}
        disabled={disabled}
        onClick={onClick}
        sx={{
          gap: 0.5,
          '& .MuiButton-startIcon': { mr: 0 },
          borderColor: color,
          bgcolor: alpha(color, 0.06),
          color,
          '&:hover': {
            borderColor: color,
            bgcolor: alpha(color, 0.12),
          },
        }}
      >
        {children}
      </Button>
    );
  },
);
